<template>
    <div v-if="showSidebarMenu" class="kfc_sidebar">
        <ul class="sidebar_container">
            <li class="category-item" v-for='(categoryItem, index) in cats' :key='categoryItem.id'>
                <a class="page-scroll __kfc_r_7" :data-id="'#category' + index" @click="menuTabPane(index)">
                    <div class="side-item" :class="index === 0 ? 'active' : ''">
                        <div class="left-box"></div>
                        <div class="right-box">
                            <span v-if="locale == 'mn'">
                                {{ categoryItem.category_mon }}
                            </span>
                            <span v-else>
                                {{ categoryItem.category_en }}
                            </span>
                        </div>
                    </div>
                </a>
            </li>
        </ul>
    </div>
    <div v-if="!showSidebarMenu" class="scroll-menu">
        <!-- <vue-scroll-snap :horizontal="true">
            <div class="category-item" v-for='(categoryItem, index) in cats' :key='categoryItem.id'>
                <a class="page-scroll __kfc_r_7" :data-id="'#category' + index" @click="menuTabPane(index)">
                    <div class="side-item __kfc_flex __kfc_flex_column" :class="index === 0 ? 'active' : ''">
                        <div class="top-box">
                            <span v-if="locale == 'mn'">
                                {{ categoryItem.category_mon }}
                            </span>
                            <span v-else>
                                {{ categoryItem.category_en }}
                            </span>
                        </div>
                        <div class="bottom-box">
                        </div>
                    </div>
                </a>
            </div>
        </vue-scroll-snap> -->
        <div class="horizontalCategory" :horizontal="true">
            <div class="category-item" v-for='(categoryItem, index) in cats' :key='categoryItem.id'>
                <a class="page-scroll __kfc_r_7" :data-id="'#category' + index" @click="menuTabPane(index)">
                    <div class="side-item __kfc_flex __kfc_flex_column" :class="index === 0 ? 'active' : ''">
                        <div class="top-box">
                            <span v-if="locale == 'mn'">
                                {{ categoryItem.category_mon }}
                            </span>
                            <span v-else>
                                {{ categoryItem.category_en }}
                            </span>
                        </div>
                        <div class="bottom-box">
                        </div>
                    </div>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import Req from '@/utils/Request'
import { computed, onMounted, ref } from 'vue'
import { useStore } from 'vuex'
import VueScrollSnap from "vue-scroll-snap";

export default {
    props: ['showSidebarMenu'],
    components: { VueScrollSnap },
    setup (props) {
        const store = useStore()
        const { showSidebarMenu } = props;
        const cats = computed(() => store.getters['menu/getCats'])
        const locale = computed(() => store.getters['locale'])
        const scrollMenuTop = ref(null);
        // const activeCategoryIndex = ref(0);
        const menuTabPane = (index) => {
            const elementTop = document.getElementById('category' + index).offsetTop;
            const menu_container = document.querySelector('.menu_container').offsetHeight;
            const contentOffsetTop = document.querySelector('.__kfc_content').offsetTop;
            window.scroll({ top: elementTop + contentOffsetTop - menu_container, behavior: "smooth" });
        }

        return {
            cats, locale, showSidebarMenu, scrollMenuTop, menuTabPane
        }
    }
}
</script>

<style lang="scss" scoped>
.kfc_sidebar {
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    max-width: 300px;

    @media (max-width: 1320px) {
        // display: none;
    }

    // left: 0;
    .sidebar_container {
        list-style: none;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        gap: 8px;
        margin: 0;
        padding: 0;
        position: absolute;
        width: 80%;
        top: 115px;

        a {
            color: $dark90;
            text-decoration: none;

            .active {
                color: $whiteMain;
            }

            &:hover {
                text-decoration: none;
            }
        }

        .category-item {
            width: 100%;
            cursor: pointer;

            &:hover {
                .side-item {
                    .right-box {
                        transition: ease-out 0.1s;
                        background: $redMain;
                        color: $whiteMain;
                    }

                    .left-box {
                        background: $dark90;
                    }
                }
            }
        }

        .side-item {
            display: flex;

            .left-box {
                background: $whiteMain;
                width: 30px;
                flex-shrink: 0;
            }

            .right-box {
                padding: 13px 30px;
                width: 100%;
            }

        }

        .side-item.active {
            .left-box {
                background: $dark90;
            }

            .right-box {
                background: $redMain;
                // transition: ease-out 0.1s;

            }
        }

    }
}

.scroll-menu {
    margin-top: 16px;
    margin-bottom: 16px;

    .horizontalCategory {
        display: flex;
        width: 100%;
        overflow-x: scroll;
        // scroll-behavior: smooth;
    }

    .category-item {
        cursor: pointer;
        // scroll-snap-align: center;

        @media (min-width: 769px) {
            &:hover {
                .side-item {
                    .top-box {
                        background: $redMain;
                        color: $whiteMain;
                        transition: ease-out 0.1s;
                    }

                    .bottom-box {
                        background: $dark90;
                    }
                }
            }
        }
    }

    .top-box {
        padding: 8px 16px;
        color: $dark40;
        width: max-content;
    }

    .bottom-box {
        height: 6px;
        background: none;
    }

    .side-item.active {
        .top-box {
            color: $whiteMain;
            background: $redMain;
        }

        .bottom-box {
            background: $dark90;
        }
    }
}
</style>